import { ModalYesNo } from '@scripsteam/scrips-signal-ds';
/**
 * CancelChangesDialog — destructive confirm shown when the user tries to
 * leave the patient-edit page with unsaved form edits. Mirrors Flutter
 * `cancelCreatingDialog()` at `create_patient_screen.dart:249-261`:
 *
 *   title:   "Do you really want to cancel?"
 *   message: "Your progress will be discarded and the changes will not be saved."
 *
 * Destructive Confirm (Flutter `isRemove: true`), Cancel keeps editing.
 */


export interface CancelChangesDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function CancelChangesDialog({
  open,
  onOpenChange,
  onConfirm,
}: CancelChangesDialogProps) {
  return (
    <ModalYesNo
      open={open}
      onCancel={() => onOpenChange(false)}
      title="Do you really want to cancel?"
      message="Your progress will be discarded and the changes will not be saved."
      cancelLabel="Keep editing"
      confirmLabel="Discard"
      onConfirm={onConfirm}
      destructive
    />
  );
}
